import { render, staticRenderFns } from "./settings-animations.vue?vue&type=template&id=70b949e6&scoped=true&"
import script from "./settings-animations.vue?vue&type=script&lang=js&"
export * from "./settings-animations.vue?vue&type=script&lang=js&"
import style0 from "./settings-animations.vue?vue&type=style&index=0&id=70b949e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b949e6",
  null
  
)

export default component.exports